<template>
  <div class="page">
    <!-- 背景 -->
    <div class="banner">
      <div class="banner-module">
        <img loading="lazy" src="@/assets/AboutUS/bg_aboutUS.jpg" />
      </div>
      <div class="banner-wrap">
        <div class="banner-content">
          <p class="gray">关于我们</p>
          <img loading="lazy" src="@/assets/AboutUS/logo_aboutUS.png" />
        </div>
      </div>
    </div>

    <!-- 公司简介 -->
    <div class="content-wrap fade-in-section">
      <div class="content-title">公司简介</div>
      <ul>
        <li class="clearfix list">
          <div class="list-imgOne common">
            <img
              loading="lazy"
              src="@/assets/AboutUS/themeLogo.png"
              alt
              class="fadeInup"
            />
          </div>
          <div class="list-text">
            <p class="title">深圳云码通科技有限公司</p>
            <p class="describe-text">
              &#12288;&#12288;深圳云码通科技有限公司是一家专注于智能机器人及数字人技术研发与应用的高新技术企业。公司以人工智能、机器视觉、深度学习和软硬件一体化能力为核心，致力于为工业制造、物流配送、安保巡逻等多个场景提供先进的机器人解决方案。
            </p>
            <p class="describe-text">
              &#12288;&#12288;近年来，公司重点布局数字人产品线，推出包括移动数字人、迷你数字人在内的多项创新模块，通过高度拟人化的交互与智能服务能力，为金融、政务、零售、教育等行业提供沉浸式数字体验与高效业务支持。
            </p>
            <p class="describe-text">
              &#12288;&#12288;公司先后获评国家高新技术企业、深圳市“专精特新”企业，并通过ISO27001信息安全管理体系认证、信息系统安全等级保护三级、CFCA安全认证及华为技术认证，拥有相关专利和软件著作权40余项，持续以技术创新推动智能机器人及数字人应用的普及与进化。
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- 企业文化 -->
    <div class="content-culture fade-in-section">
      <div class="content-title">公司文化</div>
      <div class="content">
        <div
          class="content-item"
          v-for="(item, index) in cultures"
          :key="`culture-${index}`"
        >
          <img loading="lazy" :src="item.url" />
          <div class="text">
            <p class="name">{{ item.name }}</p>
            <p
              class="describe-text"
              v-for="(p, index) in item.text"
              :key="`text-${index}`"
            >
              <img loading="lazy" src="@/assets/AboutUS/item1.png" alt />
              {{ p }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 发展历程 -->
    <div class="content-develop fade-in-section">
      <div class="content-title">发展历程</div>
      <DevelopLine :nodeDatas="developDatas" :activetNode="0" />
    </div>

    <!-- 获得荣誉 -->
    <div class="content-honor fade-in-section">
      <div class="content-title">公司荣誉</div>
      <!-- 第一行：从右到左滚动 -->
      <div class="honor-container">
        <div class="honor-track track-left">
          <div class="honor-list">
            <div
              class="honor-item"
              v-for="(item, index) in honorDatas1"
              :key="`honor1-${index}`"
            >
              <img loading="lazy" :src="item.url" />
              <p class="describe-text" style="user-select: none">
                {{ item.name }}
              </p>
            </div>
          </div>
          <!-- 复制一份实现无线滚动 -->
          <div class="honor-list">
            <div
              class="honor-item"
              v-for="(item, index) in honorDatas1"
              :key="`honor1-${index}`"
            >
              <img loading="lazy" :src="item.url" />
              <p class="describe-text" style="user-select: none">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二行：从左到右滚动 -->
      <div class="honor-container">
        <div class="honor-track track-right">
          <div class="honor-list">
            <div
              class="honor-item"
              v-for="(item, index) in honorDatas2"
              :key="`honor2-${index}`"
            >
              <img loading="lazy" :src="item.url" />
              <p class="describe-text" style="user-select: none">
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="honor-list">
            <div
              class="honor-item"
              v-for="(item, index) in honorDatas2"
              :key="`honor2-${index}`"
            >
              <img loading="lazy" :src="item.url" />
              <p class="describe-text" style="user-select: none">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import DevelopLine from "@/components/DevelopLine.vue";

export default {
  name: "page",
  components: {
    DevelopLine
  },
  data () {
    return {
      // 企业文化
      cultures: [
        {
          url:require('@/assets/AboutUS/mission.png'),
          name:'企业使命',
          text:[
            '以创新驱动发展，以客户为中心，为客户提供高效、智能的解决方案，助力产业升级。'
          ]
        },
        {
          url:require('@/assets/AboutUS/vision.png'),
          name:'企业愿景',
          text:[
            '成为智能机器人领域的领军企业，用科技赋能未来。'
          ]
        },
        {
          url:require('@/assets/AboutUS/value.png'),
          name:'核心价值观',
          text:[
            '敢创·敢为：打破边界，用算法与硬件的融合探索AI极限；',
            '匠心·智造：以匠心打磨细节，用可靠智能兑现承诺；',
            '共生·共进：与客户、伙伴、员工共创价值，共享智能未来。'
          ]
        },
        {
          url:require('@/assets/AboutUS/spirit.png'),
          name:'企业精神',
          text:[
            '务实： 脚踏实地，注重实效，以结果为导向。',
            '进取： 积极向上，永葆激情，不断追求卓越。',
            '开放： 拥抱变化，乐于分享，与合作伙伴共赢发展。'
          ]
        }
      ],
      // 发展历程
      developDatas: [
        {
          title: '公司成立',
          year: '2015年',
          desc: [
            '公司正式成立，开启新征程',
          ]
        },
        {
          title: '第一阶段',
          year: '2015-2017年',
          desc: [
            '荣获“国家高新技术企业证书”',
            '荣获“双软企业证书”',
            '荣获“3A企业信用等级证书”',
            '荣获“深圳市科创委专项创业资助”'
          ]
        },
        {
          title: '第二阶段',
          year: '2018年',
          desc: [
            '荣获“深圳市高新技术企业政府奖励”',
            '荣获“深圳市科创委研发投入专项资金补贴”',
            '加入“深圳市高新技术产业协会”',
            '加入“深圳市软件行业协会”'
          ]
        },{
          title: '第三阶段',
          year: '2019-2020年',
          desc: [
            '荣获“国家高新技术企业证书”',
            '荣获“增值电信业务经营许可证（ICP证书）”',
            '荣获“信息系统安全等级保护证书（等保三级）”',
            '荣获“华为技术认证证书”'
          ]
        },{
          title: '第四阶段',
          year: '2021-2022年',
          desc: [
            '荣获2022年度人工智能“创新示范应用奖”，光纤线序检测仪投产，公司向智能制造、工业4.0方向迈进，开启新的征程。',
            '荣获“深圳市专精特新中小企业”称号',
            '荣获“ISO27001信息安全管理体系认证证书”'
          ]
        },
        {
          title: '第五阶段',
          year: '2023-2024年',
          desc: [
            '龙马机器人系列投产，荣获最佳人工智能服务平台奖，进一步巩固在人工智能领域的领先地位。',
          ]
        },
        {
          title: '持续发展中...',
          year: '2025年...',
          desc: [ ]
        },
      ],
      // 公司荣誉
      honorDatas1: [
        {
          url:require('@/assets/AboutUS/honors/touzi.png'),
          name:'2025 最具投资价值奖'
        },
        {
          url:require('@/assets/AboutUS/honors/gaoxinjisu.jpg'),
          name:'2024 高新技术企业证书'
        },
        {
          url:require('@/assets/AboutUS/honors/zhuangjintexin.png'),
          name:'2024 专精特新中小企业'
        },
        {
          url:require('@/assets/AboutUS/honors/hangyezeren.png'),
          name:'2024 行业责任担当'
        },
        {
         url:require('@/assets/AboutUS/honors/zhinengfuwu.jpg'),
          name:'2024年 最佳人工智能服务平台奖'
        },

      ],
      honorDatas2: [
        {
          url:require('@/assets/AboutUS/honors/chaungxin.jpg'),
          name:'2022年 创新示范应用奖:AI端子检测平台'
        },
        {
          url:require('@/assets/AboutUS/honors/kejijinbu.jpg'),
          name:'2023 科技进步一等奖'
        },
        {
          url:require('@/assets/AboutUS/honors/baozhuang.png'),
          name:'2023年 最佳人工服务平台:包装箱缺陷检测；行业责任担当'
        },
        {
          url:require('@/assets/AboutUS/honors/zhinengxunjian.jpg'),
          name:'2024 智能巡检机器人专利证书'
        },
        {
          url:require('@/assets/AboutUS/honors/fengkong.jpg'),
          name:'2025 风控平台系统三级'
        },
      ]
    }
  },
  mounted() {
    // 创建观察者实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // 只触发一次
        }
      });
    }, {
      threshold: 0.1 // 元素进入视口10%时触发
    });

    // 监听所有需要渐入的元素
    document.querySelectorAll('.fade-in-section').forEach(section => {
      observer.observe(section);
    });
  },
}
</script>

<style scoped lang="scss">
// 背景
.banner {
  width: 100%;
  position: relative;
  overflow: hidden;
  .banner-module {
    height: 500px;
    overflow: hidden;
    position: relative;
    img {
      object-fit: cover;
      min-width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      user-select: none;
    }
  }
  .banner-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .banner-content {
      justify-content: left;
      height: 100%;
      display: flex;
      align-items: center;
      width: 1200px;
      z-index: 9;
      .gray {
        white-space: nowrap;
        font-size: 5rem;
        font-weight: 600;
        color: #00f0fa;
        margin-bottom: 3rem;
        margin-right: 28rem;
        line-height: 5.6rem;
      }
    }
  }
}

// 公司简介
.content-wrap {
  background-color: #f8f9fb;
  padding-bottom: 0;
  width: 100%;
  text-align: center;
  ul {
    width: 1200px;
    margin: 0 auto;
    li:first-child {
      padding-top: 0;
    }
    .list {
      padding-top: 7rem;
      padding-bottom: 8rem;
      border-bottom: 1px solid #e4e8f3;
      overflow: hidden;
      .list-imgOne {
        float: left;
        margin-right: 60px;
      }
      .common {
        width: 600px;
        height: 42rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
          user-select: none;
        }
      }
      .list-text {
        width: calc(100% - 660px);
        height: auto;
        float: left;
        text-align: left;
        .title {
          font-size: 2.4rem;
          font-weight: 600;
          color: #34363d;
          line-height: 3rem;
          margin-bottom: 0;
        }
        .text {
          font-size: 1.6rem;
          font-weight: 400;
          color: #5e636e;
          line-height: 2rem;
          margin: 0;
        }
      }
    }
  }
}

// 企业文化
.content-culture {
  width: 100%;
  .title {
    margin-bottom: 5rem;
    font-size: 3.2rem;
    font-weight: 600;
    color: #34363d;
    user-select: none;
  }
  .content {
    display: flex;
    width: 1200px;
    flex-wrap: wrap;
    margin: 0 auto;
    .content-item {
      width: 580px;
      height: 250px;
      display: flex;
      background-color: rgb(248, 249, 251);
      padding: 2rem;
      align-items: center;
      margin: 10px;
      img {
        display: inline-block;
        width: 12rem;
        height: 13rem;
        margin-right: 1.2rem;
        user-select: none;
      }
      .name {
        font-size: 2.5rem;
        font-weight: bold;
        margin: 0;
      }
      .text {
        img {
          width: 2rem;
          height: 2rem;
        }
        p {
          line-height: 1.2;
        }
      }
    }
  }
}

// 发展历程
.content-develop {
  width: 100%;
  text-align: center;
}

// 获得荣誉
.content-honor {
  width: 100%;
  padding: 3rem 0 5rem;
  text-align: center;
  .honor-container {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    background-color: #f8f9fb;
    padding: 2rem 0;
    // 滚动轨道：包含两个列表，通过动画移动
    .honor-track {
      display: flex;
      .honor-list {
        display: flex;
        justify-content: flex-start;
        flex-shrink: 0; // 禁止列表被压缩（关键：确保两个列表完整显示）
        gap: 1.5rem;
        padding: 0 1rem; // 左右内边距，避免边缘紧贴
        .honor-item {
          width: 250px;
          height: 350px;
          background-color: #e8ecf3;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          align-content: space-between;
          img {
            display: block;
            height: 80%;
            width: 80%;
            object-fit: contain; // 图片自适应，不拉伸
            user-select: none; // 禁止选中图片
          }
          p {
            min-height: 15%;
            margin: 0;
            line-height: 1.3;
          }
        }
      }
    }
    // 从右到左
    .track-left {
      animation: scrollLeft 30s linear infinite; // 滚动动画：30秒/次，匀速，无限循环
      @keyframes scrollLeft {
        0% {
          transform: translateX(0); // 初始位置：轨道左侧对齐容器
        }
        100% {
          // 最终位置：轨道向左移动一个列表的宽度（实现无缝衔接）
          transform: translateX(-100%);
        }
      }
    }
    // 从左到右
    .track-right {
      animation: scrollRight 35s linear infinite; // 滚动动画：30秒/次，匀速，无限循环
      @keyframes scrollRight {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
  }
  // 鼠标悬浮时停止滚动
  .honor-container:hover .honor-track {
    animation-play-state: paused;
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .banner {
    .banner-module {
      height: 25vh;
    }
    .banner-wrap {
      .banner-content {
        width: 100vw;
        .gray {
          font-size: 2rem;
          height: 3rem;
          margin-right: 10rem;
          margin-left: 3rem;
        }
        img {
          height: 12.5vh;
        }
      }
    }
  }
  .content-wrap {
    padding: 2rem 0 0;
    box-sizing: border-box; // 关键：让padding不影响总宽度
    .content-title {
      display: none;
    }
    ul {
      width: 100% !important;
      max-width: 100% !important; // 防止任何情况下超出屏幕
      padding: 0 15px !important;
      margin: 0 !important;
      box-sizing: border-box; // 确保padding包含在width内
      .list {
        padding: 3rem 0;
        overflow: hidden; // 彻底清除浮动影响
        .list-imgOne {
          display: none;
        }
        .list-text {
          width: 100% !important;
          float: none !important;
          padding: 0 5px !important;
          box-sizing: border-box;
          .title {
            font-size: 1.8rem;
            margin-bottom: 1rem;
            text-align: center;
          }
        }
      }
    }
  }
  .content-culture {
    padding: 2rem 0 0;
    .content {
      width: 100%;
      padding: 0 10px;
      .content-item {
        width: 100%;
        height: auto;
        margin: 10px 0;
        text-align: center;
        padding: 1.5rem;
        img {
          width: 5rem;
          height: 5rem;
        }
        .name {
          font-size: 1.8rem;
          margin-bottom: 1rem;
        }
        .text {
          text-align: left;
          img {
            width: 1.2rem;
            height: 1.2rem;
            display: inline-block;
            margin-right: 0.5rem;
          }
        }
      }
    }
  }
  .content-develop {
    padding: 2rem 0 0;
    padding: 0 10px;
  }
  .content-honor {
    padding: 2rem 0 3rem;
    .honor-container {
      width: 100%;
      padding: 1rem 0;
      .honor-track {
        .honor-list {
          gap: 1rem;
          padding: 0 0.5rem;
          .honor-item {
            width: 150px;
            height: 220px;
            img {
              height: 200px;
            }
            p {
              font-size: 12px !important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AboutUS.vue